const dateToString = (date) => {
    const newDate = new Date(date);
    let minutes = newDate.getMinutes();
    if (minutes < 10) {
        minutes = `0${minutes}`;
    }
    return `${newDate.getDate()}/${newDate.getMonth() + 1}/${newDate.getFullYear()}`;
}

export default dateToString;